import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch, ref, onMounted, onBeforeUnmount, computed } from "vue";
import DashboardSidebar from "@/components/Sidebars/DashboardSidebar.vue";
import DashboardHeader from "@/components/Headers/DashboardHeader.vue";
import DashboardFooter from "@/components/Footers/DashboardFooter.vue";
import DashboardSettingsDrawer from "@/components/Sidebars/DashboardSettingsDrawer.vue";
import { useRouter, useRoute } from "vue-router";
import cookiesConFig from "@/utils/CookiesConfig";
import {
  DARK_TYPE,
  SIDEBAR_COLOR,
  SIDEBAR_THEME,
  SIDEBAR_TEXT_COLOR,
  SIDEBAR_SELECTED_TEXT_COLOR,
  SIDENAV_TYPE,
  NAVBAR_FIXED,
  SHOW_SETTINGS_DRAWER,
} from "@/const/ConstCookies";
import store from '@/store/index'
const LG_BREAKPOINT = 992;

export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const route = useRoute();
const isMobileViewport = () =>
  typeof window !== "undefined" && window.innerWidth < LG_BREAKPOINT;

const sidebarCollapsed = ref(isMobileViewport());
const wasMobile = ref(isMobileViewport());
const isMobile = ref(isMobileViewport());
const sidebarColor = ref("primary");
const sidebarTextColor = ref("primary");
const sidebarSelectedTextColor = ref("white");
const sidenavType = ref(true);
const sidebarTheme = ref("dark");
const navbarFixed = ref(false);
const showSettingsDrawer = ref(false);
const darkType = ref("");
// const layoutClass = computed(() => {
//   return route.meta.layoutClass;
// });
const layoutClass = ref('default');
const isLayoutClass = computed(() => {
  return store.getters.isLayoutClass
})

watch(isLayoutClass, async (newValue, oldValue) => {
  layoutClass.value = newValue
  if (newValue == null || newValue == '') {
    layoutClass.value = 'default'
  } else {
    layoutClass.value = newValue
  }
})

const syncSidebarForViewport = () => {
  const mobile = isMobileViewport();
  isMobile.value = mobile;
  // Only auto-hide when crossing from desktop -> tablet/mobile
  if (mobile && !wasMobile.value) {
    sidebarCollapsed.value = true;
  }
  // Restore sidenav type when returning to desktop
  if (!mobile && wasMobile.value) {
    sidebarCollapsed.value = !sidenavType.value;
  }
  wasMobile.value = mobile;
};

const showSidebar = computed(() => (isMobile.value ? !sidebarCollapsed.value : true));
const isSidebarMini = computed(() => !isMobile.value && sidebarCollapsed.value);
const isDarkMode = computed(() => darkType.value === "dark-mode");

const applyDocumentDarkMode = (enabled: boolean) => {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark-mode", enabled);
  document.body.classList.toggle("dark-mode", enabled);
};

const readSidenavType = () => {
  const raw = cookiesConFig.getCokies(SIDENAV_TYPE);
  if (raw === "" || raw === null || raw === undefined) return true;
  return raw === "true" || raw === true;
};

const applySidenavType = (full: boolean) => {
  sidenavType.value = full;
  cookiesConFig.setCokies(SIDENAV_TYPE, full);
  if (!isMobile.value) {
    sidebarCollapsed.value = !full;
  }
};

onMounted(() => {
  modelConfig();
  isMobile.value = isMobileViewport();
  if (isMobileViewport()) {
    sidebarCollapsed.value = true;
  } else {
    sidebarCollapsed.value = !sidenavType.value;
  }
  applyDocumentDarkMode(isDarkMode.value);
  window.addEventListener("resize", syncSidebarForViewport);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", syncSidebarForViewport);
  applyDocumentDarkMode(false);
});

const toggleSidebar = (val: any) => {
  sidebarCollapsed.value = val;
  if (!isMobile.value) {
    const full = !val;
    sidenavType.value = full;
    cookiesConFig.setCokies(SIDENAV_TYPE, full);
  }
};

const toggleSettingsDrawer = (val: any) => {
  cookiesConFig.setCokies(SHOW_SETTINGS_DRAWER, val);
  showSettingsDrawer.value = val;
};

const toggleNavbarPosition = (val: any) => {
  cookiesConFig.setCokies(NAVBAR_FIXED, val);
  navbarFixed.value = val;
};

const updateSidenavType = (val: any) => {
  applySidenavType(val === true || val === "true");
};

const updateSidebarColor = (val: any) => {
  const color = val || "primary";
  cookiesConFig.setCokies(SIDEBAR_COLOR, color);
  sidebarColor.value = color;
};

const updateSidebarTextColor = (val: any) => {
  const color = val || "primary";
  cookiesConFig.setCokies(SIDEBAR_TEXT_COLOR, color);
  sidebarTextColor.value = color;
};

const updateSidebarSelectedTextColor = (val: any) => {
  const color = val || "white";
  cookiesConFig.setCokies(SIDEBAR_SELECTED_TEXT_COLOR, color);
  sidebarSelectedTextColor.value = color;
};

const darkModel = (val: any) => {
  const mode = val === "dark-mode" ? "dark-mode" : "";
  cookiesConFig.setCokies(DARK_TYPE, mode);
  darkType.value = mode;
  applyDocumentDarkMode(mode === "dark-mode");
};

const modelConfig = () => {
  sidebarColor.value = cookiesConFig.getCokies(SIDEBAR_COLOR) || "primary";
  sidebarTextColor.value = cookiesConFig.getCokies(SIDEBAR_TEXT_COLOR) || "primary";
  sidebarSelectedTextColor.value =
    cookiesConFig.getCokies(SIDEBAR_SELECTED_TEXT_COLOR) || "white";
  sidenavType.value = readSidenavType();
  sidebarTheme.value = cookiesConFig.getCokies(SIDEBAR_THEME) || "dark";
  navbarFixed.value = cookiesConFig.getCokiesBoolean(NAVBAR_FIXED);
  showSettingsDrawer.value = cookiesConFig.getCokiesBoolean(SHOW_SETTINGS_DRAWER);
  const savedDark = cookiesConFig.getCokies(DARK_TYPE);
  darkType.value = savedDark === "dark-mode" ? "dark-mode" : "";
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(darkType.value)
  }, [
    _createVNode(_component_a_layout, {
      class: _normalizeClass(["layout-dashboard", [
      navbarFixed.value ? 'navbar-fixed' : '',
      showSidebar.value ? 'has-sidebar' : '',
      isSidebarMini.value ? 'has-sidebar-mini' : '',
      _unref(route).meta.layoutClass
    ]]),
      id: "layout-dashboard"
    }, {
      default: _withCtx(() => [
        _createVNode(DashboardSidebar, {
          sidebarCollapsed: sidebarCollapsed.value,
          sidebarColor: sidebarColor.value,
          sidebarTextColor: sidebarTextColor.value,
          sidebarSelectedTextColor: sidebarSelectedTextColor.value,
          sidebarTheme: sidebarTheme.value,
          onToggleSidebar: toggleSidebar
        }, null, 8, ["sidebarCollapsed", "sidebarColor", "sidebarTextColor", "sidebarSelectedTextColor", "sidebarTheme"]),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(DashboardHeader, {
              sidebarCollapsed: sidebarCollapsed.value,
              navbarFixed: navbarFixed.value,
              sidebarColor: sidebarColor.value,
              sidebarTextColor: sidebarTextColor.value,
              sidebarSelectedTextColor: sidebarSelectedTextColor.value,
              onToggleSettingsDrawer: toggleSettingsDrawer,
              onToggleSidebar: toggleSidebar
            }, null, 8, ["sidebarCollapsed", "navbarFixed", "sidebarColor", "sidebarTextColor", "sidebarSelectedTextColor"]),
            _createVNode(_component_a_layout_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            }),
            _createVNode(DashboardFooter),
            _withDirectives(_createElementVNode("div", {
              class: "sidebar-overlay",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarCollapsed.value = true))
            }, null, 512), [
              [_vShow, isMobile.value && !sidebarCollapsed.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(DashboardSettingsDrawer, {
          showSettingsDrawer: showSettingsDrawer.value,
          navbarFixed: navbarFixed.value,
          sidenavType: sidenavType.value,
          darkMode: isDarkMode.value,
          sidebarColor: sidebarColor.value,
          sidebarTextColor: sidebarTextColor.value,
          sidebarSelectedTextColor: sidebarSelectedTextColor.value,
          onToggleSettingsDrawer: toggleSettingsDrawer,
          onToggleNavbarPosition: toggleNavbarPosition,
          onUpdateSidenavType: updateSidenavType,
          onUpdateSidebarColor: updateSidebarColor,
          onUpdateSidebarTextColor: updateSidebarTextColor,
          onUpdateSidebarSelectedTextColor: updateSidebarSelectedTextColor,
          onDarkModel: darkModel
        }, null, 8, ["showSettingsDrawer", "navbarFixed", "sidenavType", "darkMode", "sidebarColor", "sidebarTextColor", "sidebarSelectedTextColor"])
      ]),
      _: 1
    }, 8, ["class"])
  ], 2))
}
}

})